/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UnregisterToEventDto { 
    /**
     * Current member or attendee who will become the owner.
     */
    nextOwnerId?: string;
    eventId: string;
    reason: UnregisterToEventDto.ReasonEnum;
    reasonCustomText?: string;
}
export namespace UnregisterToEventDto {
    export type ReasonEnum = 'not_available' | 'imperative_personal' | 'imperative_professional' | 'hurt' | 'weather_condition' | 'other';
    export const ReasonEnum = {
        NotAvailable: 'not_available' as ReasonEnum,
        ImperativePersonal: 'imperative_personal' as ReasonEnum,
        ImperativeProfessional: 'imperative_professional' as ReasonEnum,
        Hurt: 'hurt' as ReasonEnum,
        WeatherCondition: 'weather_condition' as ReasonEnum,
        Other: 'other' as ReasonEnum
    };
}


